// Definição para o modal de busca de Vendedores
// Factory function - recebe idEmpresa como parâmetro

export const criarConfigBuscaParceiroVendedor = (idOrganizacao, lstPapelComercialPadrao = null) => {
  const camposFiltro = [
    { model: 'busca', label: 'Nome ou CPF', tipo: 'text' },
    { model: 'idOrganizacao', label: 'Empresa', tipo: 'hidden', value: idOrganizacao },
    { model: 'isVendedor', label: 'Vendedor', tipo: 'hidden', value: true },
    {
      model: 'lstPapelComercialPadrao',
      label: 'Papel Comercial',
      tipo: 'select',
      value: lstPapelComercialPadrao || '',
      optionsEndpoint: 'ListasSistema/lookup/PARCEIRO_VND_PAPEL_COM',
      optionsMapper: (item) => ({
        value: item.idListaSistemaItem,
        label: item.textoLista
      })
    }
  ]

  let titulo = 'Pesquisar Vendedor'
  if (lstPapelComercialPadrao) {
    titulo = 'Pesquisar Gestor Comercial'
  }

  return {
    label: lstPapelComercialPadrao ? 'Gestor Comercial' : 'Vendedor',
    placeholder: 'Nome ou CPF...',
    titulo,
    endpointApi: 'Parceiros',
    idField: 'idParceiro',
    displayField: 'idParceiro',
    descField: 'nomeFantasia',
    camposFiltro,
    colunasGrid: [
      { header: 'Nome do Vendedor', dataField: 'nomeFantasia', width: '35%' },
      { header: 'CPF', dataField: 'documento', width: '15%' },
      { header: 'Papel Comercial', dataField: 'lstPapelComercialPadrao', width: '25%' },
      { header: 'Região Atuação', dataField: 'regiaoAtuacao', width: '25%' }
    ]
  }
}
